module.exports = __webpack_public_path__ + "static/media/logo.e3d8c4ee.svg";